import { backendUrl } from '@shared/constants/urls/appUrls';
// import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//               Отправить запрос на обновление счетчика просмотра
//------------------------------------------------------------------------------
export const postViewCountUpdate = async ({ id, content_type }) => {
  try{
    const url = `${backendUrl}/api/alpha/view-count-update/`;
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, content_type })
    };
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при обновлении счетчика просмотров: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка добавления/удаления избранного:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
